<template>
	<div class="notFound">
    	<h1>{{ msg }}</h1>
	</div>
</template>

<script>
export default {
	name: 'notFound',
	data() {
		return {msg: 'ERROR: NotFound'};
	}
};
</script>

<style>
.notFound {
  text-align: center;
  /*background-color: #2c3e50;*/
  /*margin-top: 60px;*/
}
</style>


// WEBPACK FOOTER //
// NotFound.vue?029dab66